// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flowLayout {
  margin: auto;
  max-width: 734px;
}
.flowLayout a {
  color: #19419b;
  font-weight: 700;
}
.flowLayout .logo {
  display: none;
}
.flowLayout .dataCaptureHeading {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 101;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0;
}
.flowLayout .workflowServiceName {
  float: none;
  width: 100%;
  max-width: calc(100% - 40px);
  height: 52px;
  line-height: 52px;
  overflow: hidden;
  font-size: 22px;
  font-weight: 700;
  color: #262626;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flowLayout .workflowServiceName span {
  display: inline-block;
  vertical-align: middle;
  line-height: 40px;
  max-height: 80px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flowLayout .formLayout.k-form {
  margin-bottom: 12px;
  background-color: #f8f7f3;
}
.flowLayout .flowButtons {
  width: 100%;
  max-width: 100%;
  margin: 18px auto 0 auto;
}
.flowLayout .messageBox {
  width: 100%;
  margin: 10px 0 0 0;
}
.hasNotificationBanner .flowLayout .dataCaptureHeading {
  top: var(--notification-banner-height, 0px);
}
@media (max-width: 1000px) {
  .flowLayout .workflowServiceName {
    font-size: 20px;
    max-width: calc(100% - 40px);
  }
}
@media (max-width: 799px) {
  .flowLayout .workflowServiceName {
    display: block;
    font-size: 18px;
  }
  .flowLayout .workflowServiceName:last-child {
    display: block;
  }
}
@media (max-width: 599px) {
  .flowLayout .workflowServiceName {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
  }
  .flowLayout .workflowServiceName:last-child {
    display: block;
  }
}
@media (max-width: 599px) {
  .flowLayout .dataCaptureHeading {
    left: 0;
    background-color: #fff;
    height: auto;
    min-height: 80px;
    width: 100%;
    border-bottom: 1px solid rgba(38, 38, 38, 0.2);
    padding-bottom: 10px;
  }
  .flowLayout .dataCaptureHeading + * {
    margin-top: 170px;
  }
  .flowLayout .dataCaptureHeading.noProgressBar {
    height: auto;
    min-height: 80px;
  }
  .flowLayout .dataCaptureHeading.noProgressBar + * {
    margin-top: 110px;
  }
  .flowLayout .logo {
    display: block;
    margin: 6px auto 0 auto;
    height: 25px;
  }
  .flowLayout .formLayout.k-form {
    border: none;
    border-radius: 0;
    margin-bottom: 20px;
    padding-bottom: 0;
  }
  .flowLayout .formLayout.k-form .documentFieldDropdownlist {
    padding: 0;
    margin-bottom: 20px;
  }
  .flowLayout .secondaryButton,
  .flowLayout .nextButton {
    position: relative;
  }
  .flowLayout .nextButton {
    margin-right: 10px;
  }
  .flowLayout h1 {
    width: 320px;
  }
  .flowLayout h1 + .formLayout .fieldset:first-child {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/FlowLayout.less"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,gBAAA;AADD;AADA;EAKE,cAAA;EACA,gBAAA;AADF;AALA;EAUE,aAAA;AAFF;AARA;EAcE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AAHF;AAnBA;EA0BE,WAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAlCA;EAyCG,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJH;AA5CA;EAqDE,mBAAA;EACA,yBAAA;AANF;AAhDA;EA0DE,WAAA;EACA,eAAA;EACA,wBAAA;AAPF;AArDA;EAgEE,WAAA;EACA,kBAAA;AARF;AAYA;EACC,2CAAA;AAVD;AAaA;EACC;IACC,eAAA;IACA,4BAAA;EAXA;AACF;AAcA;EACC;IACC,cAAA;IACA,eAAA;EAZA;EAcA;IACC,cAAA;EAZD;AACF;AAgBA;EACC;IACC,eAAA;IACA,YAAA;IACA,iBAAA;EAdA;EAgBA;IACC,cAAA;EAdD;AACF;AAkBA;EACC;IAEE,OAAA;IACA,sBAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,8CAAA;IACA,oBAAA;EAjBD;EASD;IAWG,iBAAA;EAjBF;EAoBC;IACC,YAAA;IACA,gBAAA;EAlBF;EAgBC;IAKE,iBAAA;EAlBH;EADD;IAyBE,cAAA;IACA,uBAAA;IACA,YAAA;EArBD;EAND;IA+BE,YAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EAtBD;EAZD;IAqCG,UAAA;IACA,mBAAA;EAtBF;EAhBD;;IA4CE,kBAAA;EAxBD;EApBD;IAgDE,kBAAA;EAzBD;EAvBD;IAoDE,YAAA;EA1BD;EA1BD;IAyDG,aAAA;EA5BF;AACF","sourcesContent":["@import (reference) '../constants.less';\n\n.flowLayout {\n\tmargin: auto;\n\tmax-width: 734px;\n\n\ta {\n\t\tcolor: @brightNavy;\n\t\tfont-weight: @sofiaFontBold;\n\t}\n\n\t.logo {\n\t\tdisplay: none;\n\t}\n\n\t.dataCaptureHeading {\n\t\tposition: fixed;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tz-index: @dataCaptureHeadingZIndex;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\tpadding: 0;\n\t}\n\n\t.workflowServiceName {\n\t\tfloat: none;\n\t\twidth: 100%;\n\t\tmax-width: calc(100% - 40px);\n\t\theight: 52px;\n\t\tline-height: 52px;\n\t\toverflow: hidden;\n\t\tfont-size: 22px;\n\t\tfont-weight: @sofiaFontBold;\n\t\tcolor: @grey26;\n\t\ttext-align: center;\n\t\tpadding: 0 20px;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\n\t\tspan {\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\tline-height: 40px;\n\t\t\tmax-height: 80px;\n\t\t\tmax-width: 100%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\t}\n\n\t.formLayout.k-form {\n\t\tmargin-bottom: 12px;\n\t\tbackground-color: @fieldBackgroundWhite;\n\t}\n\n\t.flowButtons {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tmargin: 18px auto 0 auto;\n\t}\n\n\t.messageBox {\n\t\twidth: 100%;\n\t\tmargin: 10px 0 0 0;\n\t}\n}\n\n.hasNotificationBanner .flowLayout .dataCaptureHeading {\n\ttop: var(--notification-banner-height, 0px);\n}\n\n@media (max-width: @longWorkflowServiceNameWidth) {\n\t.flowLayout .workflowServiceName {\n\t\tfont-size: 20px;\n\t\tmax-width: calc(100% - 40px);\n\t}\n}\n\n@media (max-width: 799px) {\n\t.flowLayout .workflowServiceName {\n\t\tdisplay: block;\n\t\tfont-size: 18px;\n\n\t\t&:last-child {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.flowLayout .workflowServiceName {\n\t\tfont-size: 16px;\n\t\theight: 40px;\n\t\tline-height: 40px;\n\n\t\t&:last-child {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.flowLayout {\n\t\t.dataCaptureHeading {\n\t\t\tleft: 0;\n\t\t\tbackground-color: #fff;\n\t\t\theight: auto;\n\t\t\tmin-height: @dataCaptureHeaderHeightForMobile;\n\t\t\twidth: 100%;\n\t\t\tborder-bottom: @containerBorder;\n\t\t\tpadding-bottom: 10px;\n\n\t\t\t+ * {\n\t\t\t\tmargin-top: (@dataCaptureHeaderHeightForMobile + 90px);\n\t\t\t}\n\n\t\t\t&.noProgressBar {\n\t\t\t\theight: auto;\n\t\t\t\tmin-height: @dataCaptureHeaderHeightForMobile;\n\n\t\t\t\t+ * {\n\t\t\t\t\tmargin-top: (@dataCaptureHeaderHeightForMobile + 30px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.logo {\n\t\t\tdisplay: block;\n\t\t\tmargin: 6px auto 0 auto;\n\t\t\theight: 25px;\n\t\t}\n\n\t\t.formLayout.k-form {\n\t\t\tborder: none;\n\t\t\tborder-radius: 0;\n\t\t\tmargin-bottom: 20px;\n\t\t\tpadding-bottom: 0;\n\n\t\t\t.documentFieldDropdownlist {\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\n\t\t.secondaryButton,\n\t\t.nextButton {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t.nextButton {\n\t\t\tmargin-right: 10px;\n\t\t}\n\n\t\th1 {\n\t\t\twidth: @formFieldsetWidthForMobile;\n\t\t}\n\n\t\th1 + .formLayout {\n\t\t\t.fieldset:first-child {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
